import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { green } from '../../styles/constants';

const StyledLink = styled(Link)`
  color: ${(props) => props.color};
  font-weight: 600;
  
  :hover {
    color: ${(props) => props.color};
    text-decoration: none;
    opacity: 0.8;
  }
`;

const ArrowLink = ({ overrideColor, children, ...props }) => {
  const color = overrideColor || green;

  return (
    <StyledLink color={color} {...props}>
      { children }
      <FontAwesomeIcon
        icon="long-arrow-alt-right"
        style={{ color }}
        className="ml-2"
      />
    </StyledLink>
  );
};

ArrowLink.propTypes = {
  overrideColor: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ArrowLink.defaultProps = {
  overrideColor: null,
};

export default ArrowLink;
